// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { createAsyncThunk } from "@reduxjs/toolkit";

import axiosInstance from "../../services/axiosInstance";
import { apiCall } from "../utils/utils";

// Get all Script from a show
export const fetchShowScripts = createAsyncThunk(
  "scripts/fetchShowScripts",
  async (showId, { rejectWithValue }) =>
    apiCall(() => axiosInstance.get(`script/${showId}/`), rejectWithValue),
);

// create script line
export const createScriptLine = createAsyncThunk(
  "scripts/createScriptLine",
  async ({ showId, data }, { rejectWithValue }) =>
    apiCall(
      () => axiosInstance.post(`script/${showId}/line/`, data),
      rejectWithValue,
    ),
);

// update script line
export const updateScriptLine = createAsyncThunk(
  "scripts/updateScriptLine",
  async ({ showId, lineId, data }, { rejectWithValue }) =>
    apiCall(
      () =>
        axiosInstance.patch(`script/${showId}/line/update/${lineId}/`, data),
      rejectWithValue,
    ),
);

// delete script line
export const deleteScriptLine = createAsyncThunk(
  "scripts/deleteScriptLine",
  async ({ showId, lineId }, { rejectWithValue }) =>
    apiCall(
      () => axiosInstance.delete(`script/${showId}/line/delete/${lineId}/`),
      rejectWithValue,
    ),
);

// create script subjects
export const createScriptSubjects = createAsyncThunk(
  "scripts/createScriptSubjects",
  async ({ showId, data }, { rejectWithValue }) =>
    apiCall(
      () => axiosInstance.post(`script/${showId}/subject/`, data),
      rejectWithValue,
    ),
);

// update script subjects
export const updateScriptSubjects = createAsyncThunk(
  "scripts/updateScriptSubjects",
  async ({ showId, subjectId, data }, { rejectWithValue }) =>
    apiCall(
      () =>
        axiosInstance.patch(
          `script/${showId}/subject/update/${subjectId}/`,
          data,
        ),
      rejectWithValue,
    ),
);

// delete script subjects
export const deleteScriptSubjects = createAsyncThunk(
  "scripts/deleteScriptSubjects",
  async ({ showId, subjectId }, { rejectWithValue }) =>
    apiCall(
      () =>
        axiosInstance.delete(`script/${showId}/subject/delete/${subjectId}/`),
      rejectWithValue,
    ),
);

// create script locations
export const createScriptLocations = createAsyncThunk(
  "scripts/createScriptLocations",
  async ({ showId, data }, { rejectWithValue }) =>
    apiCall(
      () => axiosInstance.post(`script/${showId}/location/`, data),
      rejectWithValue,
    ),
);

// update script locations
export const updateScriptLocations = createAsyncThunk(
  "scripts/updateScriptLocations",
  async ({ showId, locationId, data }, { rejectWithValue }) =>
    apiCall(
      () =>
        axiosInstance.patch(
          `script/${showId}/location/update/${locationId}/`,
          data,
        ),
      rejectWithValue,
    ),
);

// delete script locations
export const deleteScriptLocations = createAsyncThunk(
  "scripts/deleteScriptLocations",
  async ({ showId, locationId }, { rejectWithValue }) =>
    apiCall(
      () =>
        axiosInstance.delete(`script/${showId}/location/delete/${locationId}/`),
      rejectWithValue,
    ),
);
